export enum StandardRatesColumns {
  MENU = "menu",
  RATE_ID = "rateId",
  RATE = "rate",
  EFFECTIVE_DATE = "effectiveDate"
}

export enum StandardRatesHistoryColumns {
  RATE_ID = "rateId",
  RATE = "rate",
  EFFECTIVE_DATE = "effectiveDate",
  ACTION= "action",
  MODIFIED_DATE = "modifiedDate",
  MODIFIED_BY = "modifiedBy",
  COMMENT = "comment"
}
